<script setup lang="ts">
import { LucideTag } from 'lucide-vue-next'
import type { INews } from '~/components/entity/news'

const props = defineProps<Pick<INews, 'tags'>>()
</script>

<template>
  <div class="mt-6 flex flex-wrap gap-2 [&_div]:gap-1.5 [&_div]:px-2.5 [&_svg]:size-3.5">
    <NuxtLinkLocale v-for="tag in props.tags" :key="tag.slug" :to="`/tag/${tag.slug}`">
      <Badge rounded="full">
        <LucideTag />
        {{ tag.title }}
      </Badge>
    </NuxtLinkLocale>
  </div>
</template>
